module.exports = __webpack_public_path__ + "img/strengthscrm-image6.ac485f05.svg";